import { HiX } from 'react-icons/hi'

import { Box } from '@chakra-ui/react'

interface DrawerCloseButtonIProps {
  ariaLabel?: string
  onClick: () => void
}

export const DrawerCloseButton = ({
  ariaLabel = 'close',
  onClick,
}: DrawerCloseButtonIProps) => (
  <Box
    _active={{ bg: 'gray.200' }}
    _hover={{ bg: 'gray.100' }}
    alignItems='center'
    aria-label={ariaLabel}
    as='button'
    borderRadius='md'
    cursor='pointer'
    display='flex'
    h='30px'
    justifyContent='center'
    minWidth='30px'
    onClick={onClick}
    type='button'
    w='30px'
  >
    <HiX size={18} />
  </Box>
)
